import axios from 'axios';
import {
  APP_SETTING_FETCH_PROJECT_BEGIN,
  APP_SETTING_FETCH_PROJECT_SUCCESS,
  APP_SETTING_FETCH_PROJECT_FAILURE,
  APP_SETTING_FETCH_PROJECT_DISMISS_ERROR,
} from './constants';
import cookie from 'react-cookies';

export function fetchProject(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_FETCH_PROJECT_BEGIN,
    });
    const token = cookie.load('token');
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    };
    const { projectId } = args;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE}projects/${projectId}`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_FETCH_PROJECT_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_FETCH_PROJECT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchProjectError() {
  return {
    type: APP_SETTING_FETCH_PROJECT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_FETCH_PROJECT_BEGIN:
      return {
        ...state,
        fetchProjectPending: true,
        fetchProjectError: null,
      };

    case APP_SETTING_FETCH_PROJECT_SUCCESS:
      return {
        ...state,
        fetchProjectPending: false,
        fetchProjectError: null,
      };

    case APP_SETTING_FETCH_PROJECT_FAILURE:
      return {
        ...state,
        fetchProjectPending: false,
        fetchProjectError: action.data.error,
      };

    case APP_SETTING_FETCH_PROJECT_DISMISS_ERROR:
      return {
        ...state,
        fetchProjectError: null,
      };

    default:
      return state;
  }
}
